(function($) {
    'use strict';

    var $formBestProject = $('.js-best-projects-form');
    var $select = $formBestProject.find('#nomination');
    $select.on('change', function () {
        var value = $select.val();
        var $files = $formBestProject.find('.js-file');
        var valueRepresentation = '7';
        if ($files.length === 0) {
            return;
        }
        $files.each(function (index, element) {
            $(element).removeClass('active');
            if ($(element).data('value').toString() === value) {
                $(element).addClass('active');
            }
        });
        $formBestProject.find('.js-fields-file').addClass('active');

        if (value === valueRepresentation) {
            $formBestProject.find('.js-field-representation').addClass('active');
        } else {
            $formBestProject.find('.js-field-representation').removeClass('active');
        }
    });
})(jQuery);
